var render = function render(){var _vm=this,_c=_vm._self._c;return _c('list',{attrs:{"mode":"dataset","items":_vm.datasets},on:{"load":_vm.onLoad,"delete":_vm.onDelete}})
}
var staticRenderFns = []

export { render, staticRenderFns }